import { reportQueries } from '@/entities/report';
import { usePersistStore } from '@/shared/lib/store';
import { Icon, TextBox } from '@/shared/ui';
import { useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';

interface Props {
    resultList: API.TchDsbdOftensentsList.Res | undefined;
    addReview: (sents: string) => void;
}

interface TrProps {
    no: number;
    sentsId: number;
    sents: string;
    wrtYmd: string;
    addReview: (sents: string) => void;
}

export const SaveList: React.FC<Props> = ({ resultList, addReview }) => {
    const queryClient = useQueryClient();
    const { sUserId } = usePersistStore();
    const { mutate: modifyMutate } = reportQueries.review.postTchDsbdOftensentsMod();
    const { mutate: deleteMutate } = reportQueries.review.postTchDsbdOftensentsDel();

    const delOftensents = (sentsId: number) => {
        const req: API.TchDsbdOftensentsDel.Req = {
            userId: sUserId ?? '',
            sentsId: sentsId,
        };
        deleteMutate(req, {
            onSuccess: (res) => {
                queryClient.invalidateQueries({
                    queryKey: ['oftensent', 'list'],
                });
            },
        });
    };

    const modOftensents = async (sentsId: number, sents: string) => {
        const req: API.TchDsbdOftensentsMod.Req = {
            userId: sUserId ?? '',
            sentsId: sentsId,
            sents: sents,
        };
        modifyMutate(req, {
            onSuccess: (res) => {
                queryClient.invalidateQueries({
                    queryKey: ['oftensent', 'list'],
                });
            },
        });
    };

    const SentsTr: FC<TrProps> = ({ no, sentsId, sents, addReview }) => {
        const [ItemSents, setItemSents] = useState<string>(sents);
        const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setItemSents(e.target.value);
        };

        return (
            <tr>
                <td>{no}</td>
                <td className="text-left2">
                    <TextBox onChange={changeHandler} value={ItemSents} />
                </td>
                <td>
                    <button
                        type="button"
                        className="link-txt"
                        onClick={() => modOftensents(sentsId, ItemSents)}
                    >
                        [수정]
                    </button>
                </td>
                <td>
                    <button type="button" className="link-txt" onClick={() => addReview(ItemSents)}>
                        [반영]
                    </button>
                </td>
                <td>
                    <button
                        type="button"
                        className="item-del"
                        onClick={() => delOftensents(sentsId)}
                    >
                        <Icon icon="del02" />
                    </button>
                </td>
            </tr>
        );
    };

    return (
        <table className="table default">
            <caption>자주 쓰는 문구</caption>
            <colgroup>
                <col style={{ width: '95px' }} />
                <col />
                <col style={{ width: '80px' }} />
                <col style={{ width: '80px' }} />
                <col style={{ width: '80px' }} />
            </colgroup>
            <tbody className="size-s">
                {resultList?.resultList.map((item: DATA.Oftensents, index: number) => (
                    <SentsTr
                        key={index}
                        no={item.no}
                        sentsId={item.sentsId}
                        sents={item.sents}
                        wrtYmd={item.wrtYmd}
                        addReview={addReview}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default SaveList;
